import Vue from 'vue';

import 'core-js/features/promise'
import 'core-js/features/url-search-params'
import 'core-js/features/object/assign'
import 'whatwg-fetch'

import {baseEditor} from "./baseEditor";
import {ddToDms} from "./helpers";

import materials from "./helpers/circle-materials";
import sizes from "./helpers/circle-sizes";

import Zoom from "../components/editor/ui/Zoom";
import {cityCircleStyles} from "./city-circle/cityCircleStyles";
import {mapStyles} from "./city-circle/mapStyles";
import CircleTabs from "../components/editor/ui/tabs/CityCircleTabs";

// const CircleTabs = () => import(/* webpackChunkName: "CircleTabs" */ "../components/editor/ui/tabs/CityCircleTabs");

window.bus = new Vue({});

const app = new Vue({
    el: '#app',

    components: {
        Zoom,
        CircleTabs
    },

    mixins: [
        baseEditor
    ],

    computed: {
        computedPrintConfig() {
            return cityCircleStyles.find(item => item.slug === this.print.design) || cityCircleStyles[0]
        },
    },

    data() {
        return {
            type: 'city-circle',

            cityCircleStyles,
            sizes,
            materials,
            mapStyles,

            defaultWidth: 750,
            defaultHeight: 750,

            posterSize: {
                width: 750,
                height: 750,
            },

            initialState: {
                lat: 52.36669,
                lng: 4.89453,
                zoom: 12,
                circle: 1,

                useCoordinates: true,

                title: 'Amsterdam',
                subtitle: '',

                design: 'gradient',
                layers: 'classic',
                material: 'forex-circle',
                size: '40',
            },

            bleedStyles: {},
        }
    },

    watch: {
        'print.lng': {
            handler: function () {
                if (this.print.useCoordinates || this.print.useCoordinates === 'true') {
                    const {lng, lat} = ddToDms(this.print.lat, this.print.lng, false, true, false)
                    this.print.subtitle = `${lat} ${lng}`
                }
            }
        },
        'print.lat': {
            handler: function () {
                if (this.print.useCoordinates || this.print.useCoordinates === 'true') {
                    const {lng, lat} = ddToDms(this.print.lat, this.print.lng, false, true, false)
                    this.print.subtitle = `${lat} ${lng}`
                }
            }
        },
    }
});
